/* Size quick-add for the RE grids (collection page + homepage).
   Tap a size, it goes in the cart and the cart opens. Delegated from the document so it
   works for any grid on the page and for cards revealed later by "Show more". */
(function () {
  if (window.__reQuickAdd) { return; }
  window.__reQuickAdd = true;

  /* Rows whose sizes all fit lose the right-edge fade. Re-checked on resize. */
  function markFull(){
    document.querySelectorAll('.recg__sizes').forEach(function (row) {
      row.classList.toggle('is-full', row.scrollWidth <= row.clientWidth + 1);
    });
  }
  if (document.readyState !== 'loading') { markFull(); }
  else { document.addEventListener('DOMContentLoaded', markFull); }
  window.addEventListener('resize', markFull);
  document.addEventListener('re:grid-revealed', markFull);

  function openCart(){
    /* Use the theme's own drawer trigger so we inherit its focus trap, body lock and
       re-render. Fall back to the cart page if the drawer isn't present. */
    var trigger = document.querySelector('.js-drawer-open-cart');
    if (trigger) { trigger.click(); return; }
    window.location.href = '/cart';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-recg-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-busy')) { return; }
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-recg-add');
    var label = btn.textContent;
    btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
    .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
    .then(function () {
      btn.classList.remove('is-busy');
      btn.classList.add('is-done');
      /* The drawer renders its contents once and does NOT re-read the cart when opened, so
         adding via fetch alone leaves it saying "your bag is empty". cart:build is the
         theme's own rebuild signal. */
      var announce = function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      };
      var done = function () {
        btn.classList.remove('is-done');
        btn.textContent = label;
        openCart();
      };
      if (window.theme && theme.cart && theme.cart.getCart) {
        theme.cart.getCart().then(function (cart) { announce(cart); setTimeout(done, 220); })
          .catch(function () { announce(null); setTimeout(done, 220); });
      } else {
        announce(null);
        setTimeout(done, 260);
      }
    })
    .catch(function () {
      btn.classList.remove('is-busy');
      btn.textContent = '!';
      setTimeout(function () { btn.textContent = label; }, 1200);
    });
  });
})();
